import styled from 'styled-components'

export const MentorCardPortraitCardsContainer = styled.div`
  display: flex;
  width: 100%;
  overflow: auto;
  scroll-behavior: smooth;
  gap: 30px;
  -webkit-overflow-scrolling: touch; /* For iOS devices */
  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  padding: 20px;
  @media (min-width: 768px) {
    padding: 35px;
    gap: 60px;
  }
`

export const MentorPortraitCardContainer = styled.div`
  flex: 0 0 129px;
  flex-shrink: 0;
  padding: 10px 5px;
  border-radius: 5px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 25px;
  border: 1px solid #182a8833;
  &:hover {
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 5px;
  }
  @media (min-width: 768px) {
    padding: 20px 10px;
    flex: 0 0 229px;
    border-radius: 8px;
  }
`

export const MentorPortraitCardPicture = styled.img`
  width: 90px;
  height: 90px;
  border-radius: 50%;
  object-fit: cover;
`

export const MentorPortraitCardText = styled.div`
  font-weight: ${(props) => (props?.main ? '700' : '400')};
  font-size: ${(props) => (props?.main ? '1.25rem' : '0.8rem')};
  color: ${(props) => (props?.main ? '#3f2f63' : '#4c4c4c')};
`

export const MentorPortraitCardActionButton = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== 'desiredClick',
})`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  white-space: nowrap;
  padding: 0.25rem 1rem;
  width: 100%;
  font-weight: 700;
  border-radius: 2rem;
  border: 1px solid #7154b0;
  overflow: hidden;
  letter-spacing: 0.08rem;
  text-transform: uppercase;
  background: ${(props) => (props?.desiredClick ? '#7154b0' : 'transparent')};
  color: ${(props) => (props?.desiredClick ? '#FFF' : '#7154b0')};
  transition: all 0.1s ease-in-out;
  &:hover {
    ${(props) => !Boolean(props?.desiredClick) && 'background: #7154b0;'};
    ${(props) => !Boolean(props?.desiredClick) && 'color: #fff;'};
  }
  @media (min-width: 768px) {
    padding: 0.5rem 1rem;
  }
`
